import CmpBoxesContainer from "./CmpBoxesContainer";

export default CmpBoxesContainer;